import React, { useState } from 'react';
import WorkSpaceSetupOLd from './WorkSpaceSetupOLd';
import { Button } from '@mui/material';
import { useGetFoldersQuery } from 'store/slices/apis/dmsSlice';

const WorkSpaceSetup = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const { data, isFetching, isError, refetch: refetchRoot } = useGetFoldersQuery({ projectId: '7d9e0306-81f4-4cdc-8752-de441b460997' });
    const handleButtonClick = async () => {
        try {
            // Your API Hit Logic
            // const response = await axios.get('/api/folders');
            // setApiResponse(response.data.data);

            // Using your provided JSON structure for now:
            const mockData = data?.data;
            setApiResponse(mockData);
            setIsDialogOpen(true);
        } catch (error) {
            console.error("Error fetching folders", error);
        }
    };

    const handleFolderConfirm = (selectedFolder) => {
        console.log("User selected folder:", selectedFolder.folderName);
        console.log("Folder ID:", selectedFolder.folderId);
        // Do your next action here (e.g., upload file to this folder)
    };

    return (
        <div>
            <Button variant="outlined" onClick={handleButtonClick}>
                Open Folder Picker
            </Button>

            <WorkSpaceSetupOLd
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                folderData={apiResponse}
                onConfirm={handleFolderConfirm}
            />
        </div>
    );
};

export default WorkSpaceSetup;